import * as React from 'react';

function SvgShareIosOutline(props) {
    return (React.createElement("svg", Object.assign({ width: "24", height: "24", fill: "none", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M6.048 9.783h1.878a.724.724 0 000-1.448H6.003c-.775 0-1.403.628-1.403 1.403v10.86c0 .774.628 1.402 1.403 1.402h11.99c.775 0 1.403-.628 1.403-1.403V9.737c0-.774-.628-1.402-1.402-1.402H16.07a.724.724 0 100 1.448h1.877v10.769h-11.9V9.782z", clipRule: "evenodd" }),
        React.createElement("path", { fill: "currentColor", d: "M8.765 4.704a.724.724 0 101.036 1.012l1.473-1.508v8.018a.724.724 0 001.448 0V4.208l1.473 1.508a.724.724 0 001.036-1.012L13 2.422a1.403 1.403 0 00-2.006 0l-2.23 2.282z" })));
}

export default SvgShareIosOutline;
